import { render, staticRenderFns } from "./installStep1.vue?vue&type=template&id=6c970624&scoped=true"
import script from "./installStep1.vue?vue&type=script&lang=js"
export * from "./installStep1.vue?vue&type=script&lang=js"
import style0 from "./installStep1.vue?vue&type=style&index=0&id=6c970624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c970624",
  null
  
)

export default component.exports